import * as graphql from '@treams/treams-network';

import BulkModal from './BulkModal';

export default function BulkArchiveUserModal(props: {
	users: graphql.User[];
	onDismiss: () => void;
}) {
	const [archive] = graphql.useArchiveUserMutation();

	return (
		<BulkModal
			name="bulkArchiveUser"
			users={props.users}
			onDismiss={props.onDismiss}
			apply={async (user) => {
				try {
					await archive({ variables: { input: { id: user.id } } });
				} catch (_) {}
			}}
		/>
	);
}
